import { createUseStyles, useDarkMode } from '@glu/theming';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import styles from './Header.styles';

const useStyles = createUseStyles(styles);

interface Props {
  children: string;
  depth?: number;
}

const Header = ({ children, depth }: Props) => {
  const classes = useStyles(useMemo(() => ({ depth }), [depth]));
  const dark = useDarkMode();

  return <div className={classnames(classes.header, { [classes.dark]: dark })}>{children}</div>;
};

export default Header;
